export class User {
    role: Role;
}

export enum Role {
    Customer = 1,
    Admin = 2
  }